export default __webpack_public_path__ + "static/media/08-Napster.99637bc9.png";